import { DEFAULT_NUMBER_OF_GOALS_SKELETON_ROWS } from '../../constants';
import { useGoalsContext } from '../../contexts/GoalsContext';
import { GoalsEmptyState } from './GoalsEmptyState';
import { GoalsErrorState } from './GoalsErrorState';
import { GoalsNoResultsState } from './GoalsNoResultsState';
import { GoalsSkeletonRows } from './GoalsSkeletonRows';
import { GoalsTableRows } from './GoalsTableRows';

export const GoalsTableContent = () => {
  const { searchQuery, isLoading, hasErrors, goals } = useGoalsContext();

  const hasGoals = goals?.length > 0;
  const hasEmptyState = goals?.length === 0;
  const hasNoResults = !!searchQuery && hasEmptyState;

  switch (true) {
    case isLoading:
      return <GoalsSkeletonRows numRows={DEFAULT_NUMBER_OF_GOALS_SKELETON_ROWS} />;

    case hasErrors:
      return <GoalsErrorState />;

    case hasNoResults:
      return <GoalsNoResultsState />;

    case hasEmptyState:
      return <GoalsEmptyState />;

    case hasGoals:
      return <GoalsTableRows />;

    default:
      return null; // this should be unreachable
  }
};
